import { Popup } from '../../vendor/elix.js';
import { internal } from '../../vendor/elix.js';
import { template } from '../../vendor/elix.js';

class TpPopup extends Popup {
  constructor() {
    super();
  }
  get [internal.template]() {
    return template.concat(
      super[internal.template],
      template.html`
        <style>
          #frame {
            border-radius: 3px;
            box-shadow: 0 1px 3px rgba(0,0,0,.33);
            left: -15px;
            margin-top: 15px;
          }
          #frameContent {
            border-radius: 3px;
            width: max-content;
          }
          #backdrop {
            display: none;
          }
        </style>
      `
    );
  }
}

export default TpPopup;
